import { PagesList } from './Components/PagesList/PagesList';

export const Pages = () => <PagesList />;
